import React from 'react'

// Components
import Text from 'components/flex/Text/Text'
import TextImage from 'components/flex/Text/TextImage'
import TextCols from 'components/flex/Text/TextCols'
import TextGallery from 'components/flex/Text/TextGallery'
import TextPost from 'components/flex/Text/TextPost'
import TextVacancy from './TextVacancy'

export interface TextProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Text
  location?: any
}

interface PostProps {
  [key: string]: any
}

const Shell: React.FC<TextProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    default: Text,
    image: TextImage,
    cols: TextCols,
    gallery: TextGallery,
    post: TextPost,
    vacancy: TextVacancy,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default Shell
